module.exports = __webpack_public_path__ + "img/247-7018fe.png";